import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function useDeliveryTabShortcut(onSelect, isKnownTab) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (!isKnownTab(tab)) return;
    onSelect(tab);
    // Consume the shortcut so it cannot override another branch's restored work.
    params.delete('tab');
    const search = params.toString();
    navigate({ pathname: location.pathname, search: search ? `?${search}` : '', hash: location.hash },
      { replace: true, state: location.state });
  }, [location, navigate, onSelect, isKnownTab]);
}
